import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { customGetAPI } from "services/utils/CustomAPI";
import moment from "moment";
import dayjs from "dayjs";
import { customAPI } from "services/utils/CustomAPI";
import { rowEndStyle, tooltipStyleProps } from "services/constants/Styles";
import DateRangePicker from "react-bootstrap-daterangepicker";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { showToast } from "services/utils/Status";
import { themes } from "services/constants";
import { Loader } from "components/Loader";
import styled from "styled-components";
import { PunchDetails } from "./PunchDetails";
import { UserDetailsRow } from "components/CustomComponents/UserDetailsRow";
import { CustomButton } from "components/CustomComponents";
import {
  CustomButtonWithOutLoader,
  CustomButtonWithBorder,
} from "components/CustomComponents/CustomButton";
import { ErrorHandle } from "./ErrorHandle";
import { drawerStyle } from "services/constants";
import { childBoxStyleSpaceBetween } from "services/constants";
import { doubleArrowStyle } from "services/constants";
import { IconButton } from "@mui/material";
import { DoubleArrow } from "@mui/icons-material";
import { Paper, Box, Typography } from "@mui/material";
import { parentBoxStyle } from "services/constants";
import { ThemeProvider, createTheme } from "@mui/material/styles";
export const EditMultipleCheckInOut = ({
  setEditDetail,
  editDetail,
  shiftDetails,
  setEditState,
  departmentId,
  setRecallApi,
  isEditRecord,
  setIsEditRecord,
  reCallApi,
  setGetUpdatedData,
}) => {
  const [state, setState] = useState(() => {
    return {
      start: moment(shiftDetails?.date.split("-").reverse().join("-")),
      end: moment(shiftDetails?.date.split("-").reverse().join("-")),
    };
  });
  const { domain } = useSelector((state) => state.tokenReducer);
  const [updatePunchEntry, setUpdatePunchEntry] = useState(true);
  const [attendanceDetails, setAttendanceDetails] = useState([]);
  const [defaultData, setDefaultData] = useState([]);
  const [getData, setGetData] = useState(true);
  const [doAnyAct, setDoAnyAct] = useState(false);
  const [triggerToast, setTriggerToast] = useState(true);
  const [inBetweenDates, setInBetweenDates] = useState([
    shiftDetails?.date.split("-").reverse().join("-"),
  ]);
  const [screenLoading, setScreenLoading] = useState(false);
  const [updateError, setErrorUpdate] = useState(false);
  const [getEntryDetails, setGetEntryDetails] = useState(true);
  const [warningMessage, setHandleWarningMessage] = useState([]);

  const parseDMY = (dmy) => {
    const [day, month, year] = dmy?.split("-");
    return new Date(`${year}-${month}-${day}`);
  };

  const parseYMD = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return new Date(year, month - 1, day);
  };

  const latestPayDate = shiftDetails?.latest_pay_date
    ? parseDMY(shiftDetails?.date) > parseYMD(shiftDetails?.latest_pay_date)
    : true;

  useEffect(() => {
    if (triggerToast && !latestPayDate) {
      showToast("error", "Payroll Submitted. Not able to edit.");
      setTriggerToast(false);
    }
  }, [latestPayDate, triggerToast]);

  useEffect(() => {
    const fetchAllAttendanceDetails = async () => {
      setScreenLoading(true);
      let overallData = [];
      const promises = inBetweenDates.map(async (date) => {
        const res = await customGetAPI(
          `${domain}attendance_manual_entry/?user_id=${shiftDetails?.user_id}&date=${date}`
        );

        if (res.ok) {
          const punchEntriesWithRowId =
            res?.responseDetails?.punch_entries?.map((entry) => ({
              ...entry,
              rowId: entry.punch_id,
            })) || [];
          const data = {
            date: date,
            ...res?.responseDetails,
            punch_entries: punchEntriesWithRowId,
            entryCountMissMatch: false,
            validate: false,
            previosValidation: false,
            inoutDetailsDayCrossing: false,
            twentyFourHoursExists: false,
            duplicateEntries: false,
            shiftEndTimeBasedError: false,
            properCheckinCheckOutTimeError: false,
            early_exit: res?.responseDetails?.early_exit,
            weekoff_pay: res?.responseDetails?.weekoff_pay,
            error: "",
          };
          overallData.push(data);
          return data;
        } else {
          return null;
        }
      });
      const results = await Promise.all(promises);
      const validData = results.filter(Boolean);
      let overAllResult = [...attendanceDetails, ...validData]
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .map((item, index) => ({
          ...item,
          id: index + 1,
        }));
      setAttendanceDetails(overAllResult);
      if (getData) {
        setDefaultData(overAllResult);
        setGetData(false);
      }

      setUpdatePunchEntry(true);
      setScreenLoading(false);
      setRecallApi(true);
      setEditState(true);
    };

    if (getEntryDetails) {
      fetchAllAttendanceDetails();
      setGetEntryDetails(false);
    }
  }, [
    attendanceDetails,
    departmentId,
    domain,
    getData,
    getEntryDetails,
    inBetweenDates,
    setEditState,
    setRecallApi,
    shiftDetails.date,
    shiftDetails.shift_filter_date,
    shiftDetails?.user_id,
  ]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Mui.Tab" || event.key === "Shift")
    ) {
      return;
    }
    setEditDetail(open);
    if (open === false) {
      if (doAnyAct) {
        setDoAnyAct(false);
      }
    }
  };

  const { start, end } = state;
  const handleCallback = (start, end) => {
    setState({ start, end });
    const startDate = moment(start);
    const endDate = moment(end);
    const dates = [];

    const current = startDate.clone();
    while (current.isSameOrBefore(endDate, "day")) {
      dates.push(current.format("YYYY-MM-DD"));
      current.add(1, "day");
    }
    setInBetweenDates(dates);
    setAttendanceDetails([]);
    setGetEntryDetails(true);
    setGetData(true);
  };

  const label = start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");

  const currentDayCheck = (attendanceData) => {
    const inCount = attendanceData?.punch_entries?.filter(
      (entry) => entry.direction === "IN"
    ).length;
    const outCount = attendanceData?.punch_entries?.filter(
      (entry) => entry.direction === "OUT"
    ).length;
    if (inCount === outCount || inCount === outCount + 1) {
      attendanceData.entryCountMissMatch = false;
      return true;
    } else {
      attendanceData.entryCountMissMatch = true;
      attendanceData.twentyFourHoursExists = false;
      attendanceData.properCheckinCheckOutTimeError = false;
      return false;
    }
  };

  const pastDateCheck = (attendanceData) => {
    const inCount = attendanceData?.punch_entries.filter(
      (entry) => entry.direction === "IN"
    ).length;
    const outCount = attendanceData?.punch_entries.filter(
      (entry) => entry.direction === "OUT"
    ).length;
    if (inCount === outCount) {
      attendanceData.entryCountMissMatch = false;
      return true;
    } else {
      attendanceData.entryCountMissMatch = true;
      attendanceData.twentyFourHoursExists = false;
      attendanceData.properCheckinCheckOutTimeError = false;
      return false;
    }
  };

  const withinTwentyFourHoursFormat = (attendanceData) => {
    if (attendanceData?.punch_entries?.length !== 1) {
      const inPunches = attendanceData?.punch_entries?.filter(
        (item) => item.direction === "IN"
      );
      const earliestInPunch = attendanceData?.punch_entries?.reduce(
        (earliest, current) => {
          const earliestDate = new Date(`${earliest.date}T${earliest.time}`);
          const currentDate = new Date(`${current.date}T${current.time}`);
          return currentDate < earliestDate ? current : earliest;
        },
        inPunches[0]
      );
      const latestOutPunch = attendanceData?.punch_entries
        ?.filter((p) => p.direction === "OUT")
        .reduce((latest, current) => {
          const latestDateTime = new Date(`${latest.date}T${latest.time}`);
          const currentDateTime = new Date(`${current.date}T${current.time}`);
          return currentDateTime > latestDateTime ? current : latest;
        });
      const inDateTime = new Date(
        `${normalizeDate(earliestInPunch.date)}T${earliestInPunch.time}`
      );
      const outDateTime = new Date(
        `${normalizeDate(latestOutPunch.date)}T${latestOutPunch.time}`
      );

      const timeDiffMs = Math.abs(outDateTime - inDateTime); // in milliseconds
      const hoursDiff = timeDiffMs / (1000 * 60 * 60); // convert to hours

      const within24Hours = hoursDiff <= 24;
      if (within24Hours) {
        attendanceData.twentyFourHoursExists = false;
        return true;
      } else {
        attendanceData.twentyFourHoursExists = true;
        attendanceData.entryCountMissMatch = false;
        attendanceData.properCheckinCheckOutTimeError = false;
        return false;
      }
    } else {
      return true;
    }
  };

  const validateFieldValues = (attendanceData) => {
    const findNullValue = attendanceData?.punch_entries.filter(
      (entry) =>
        !entry.date ||
        !entry.direction ||
        !entry.date ||
        entry.date === "Invalid Date" ||
        !entry.time
    );
    if (findNullValue.length <= 0) {
      return true;
    } else {
      attendanceData.error = "Value is required";
      return false;
    }
  };

  const validateDublicateEntries = (attendanceData) => {
    let entries = attendanceData?.punch_entries;
    const countMap = {};
    entries = entries.map((data) => {
      return {
        ...data,
        fulldata: `${data?.date}_${data?.time}_${data?.direction}`,
      };
    });
    entries.forEach((item) => {
      countMap[item.fulldata] = (countMap[item.fulldata] || 0) + 1;
    });

    const duplicates = new Set(
      Object.keys(countMap).filter((key) => countMap[key] > 1)
    );
    let data = entries.filter((item) => duplicates.has(item.fulldata));
    if (data.length > 0) {
      attendanceData.duplicateEntries = true;
    }
    return data.length < 1;
  };

  const validatePreviousAndNextDayProcess = (attendanceData) => {
    let previousday = previousDayCheckOutTime(attendanceData);
    let nextday = nextDayCheckInTime(attendanceData);
    if (previousday && nextday) {
      attendanceData.inoutDetailsDayCrossing = false;
      return true;
    } else {
      attendanceData.inoutDetailsDayCrossing = true;

      return false;
    }
  };

  const previousDayCheckOutTime = (attendanceData) => {
    if (attendanceData?.previous_check_out_datetime) {
      const checkoutDateTime = new Date(
        attendanceData?.previous_check_out_datetime
      );
      let previous_day_count = 0;
      attendanceData?.punch_entries?.forEach((entry) => {
        const arrayDateTimeString = `${entry.date}T${entry.time}:00`;
        const arrayDateTime = new Date(arrayDateTimeString);
        if (arrayDateTime < checkoutDateTime) {
          previous_day_count++;
        }
      });
      return previous_day_count === 0 ? true : false;
    } else {
      return true;
    }
  };

  const entriesTimeValidation = (attendanceData) => {
    const sortedPunches = [...attendanceData?.punch_entries].sort((a, b) => {
      const dateTimeA = new Date(`${normalizeDate(a.date)}T${a.time}`);
      const dateTimeB = new Date(`${normalizeDate(b.date)}T${b.time}`);
      return dateTimeA - dateTimeB;
    });
    for (let i = 0; i < sortedPunches.length - 1; i++) {
      const current = sortedPunches[i];
      const next = sortedPunches[i + 1];
      if (current.direction === next.direction) {
        attendanceData.properCheckinCheckOutTimeError = true;
        return false;
      }
    }
    const isFirstPunchIn =
      sortedPunches.length > 0 && sortedPunches[0].direction === "IN";
    if (isFirstPunchIn) {
      attendanceData.properCheckinCheckOutTimeError = false;
      return true;
    } else {
      attendanceData.properCheckinCheckOutTimeError = true;
      return false;
    }
  };

  const nextDayCheckInTime = (attendanceData) => {
    if (attendanceData?.next_check_in_datetime) {
      const checkInDateTime = new Date(attendanceData?.next_check_in_datetime);
      let next_day_count = 0;
      attendanceData?.punch_entries?.forEach((entry) => {
        const arrayDateTimeString = `${entry.date}T${entry.time}:00`;
        const arrayDateTime = new Date(arrayDateTimeString);
        if (arrayDateTime > checkInDateTime) {
          next_day_count++;
        }
      });
      return next_day_count === 0 ? true : false;
    } else {
      return true;
    }
  };

  const validateCheckInCheckOut = (attendanceData) => {
    if (
      validateFieldValues(attendanceData) &&
      attendanceData?.punch_entries.length !== 0 &&
      validateDublicateEntries(attendanceData)
    ) {
      const today = dayjs().startOf("day");
      const yesterday = today.subtract(1, "day");
      const dateToCheck = dayjs(
        normalizeDate(attendanceData?.date),
        "YYYY-MM-DD"
      ).startOf("day");

      const isTodayOrYesterday =
        dateToCheck?.isSame(today, "day") ||
        dateToCheck?.isSame(yesterday, "day");
      if (isTodayOrYesterday) {
        if (currentDayCheck(attendanceData)) {
          return withinTwentyFourHoursFormat(attendanceData);
        }
      } else {
        if (pastDateCheck(attendanceData)) {
          return withinTwentyFourHoursFormat(attendanceData);
        }
      }
    } else {
      return false;
    }
  };

  const checkOddPunchEntry = (attendanceData) => {
    if (
      attendanceData?.punch_entries.length % 2 === 0 ||
      attendanceData?.error === "Value is required"
    ) {
      attendanceData.shiftEndTimeBasedError = false;
      return true;
    } else {
      const [startHour, startMinute] = attendanceData?.shift_start
        ?.split(":")
        ?.map(Number);
      const [endHour, endMinute] = attendanceData?.shift_end
        .split(":")
        .map(Number);
      const startInMinutes = startHour * 60 + startMinute;
      const endInMinutes = endHour * 60 + endMinute;
      let checkOverNightShiftBoolean =
        endInMinutes < startInMinutes ? true : false;
      const baseDate = dayjs(
        attendanceData?.date,
        ["YYYY-MM-DD", "DD-MM-YYYY"],
        true
      );

      let shiftEndDateTime = checkOverNightShiftBoolean
        ? baseDate
            .add(1, "day")
            .hour(endHour)
            .minute(endMinute)
            .second(0)
            .millisecond(0)
        : baseDate.hour(endHour).minute(endMinute).second(0).millisecond(0);
      const currentDateTime = dayjs();
      if (shiftEndDateTime.isAfter(currentDateTime)) {
        attendanceData.shiftEndTimeBasedError = false;
        return true;
      } else {
        attendanceData.shiftEndTimeBasedError = true;
        return false;
      }
    }
  };

  const validateOverAllPunchEntries = (attendanceDetails) => {
    const updatedAttendanceDetails = attendanceDetails.map((attendanceData) => {
      const isCheckInOutValid =
        validateCheckInCheckOut(attendanceData) || attendanceData?.validate;
      const isEntryTimeValid = entriesTimeValidation(attendanceData);
      const isPrevNextDayValid =
        validatePreviousAndNextDayProcess(attendanceData) ||
        attendanceData?.previosValidation;
      const isOddPunchValid = checkOddPunchEntry(attendanceData);
      if (
        (isCheckInOutValid &&
          isEntryTimeValid &&
          isPrevNextDayValid &&
          isOddPunchValid) ||
        attendanceData?.punch_entries?.length === 0
      ) {
        return {
          ...attendanceData,
          twentyFourHoursExists: false,
          entryCountMissMatch: false,
          properCheckinCheckOutTimeError: false,
          inoutDetailsDayCrossing: false,
          shiftEndTimeBasedError: false,
          error: "",
        };
      }
      return attendanceData;
    });
    setAttendanceDetails(updatedAttendanceDetails);
    setErrorUpdate(true);
    handleOverallErrorStatus(updatedAttendanceDetails);
  };

  const handleOverallErrorStatus = (updatedAttendanceDetails) => {
    const hasAnyErrors = updatedAttendanceDetails.some(
      (item) =>
        item.twentyFourHoursExists ||
        item.entryCountMissMatch ||
        item.properCheckinCheckOutTimeError ||
        item.inoutDetailsDayCrossing ||
        item.shiftEndTimeBasedError ||
        (item.error && item.error.trim() !== "")
    );
    if (!hasAnyErrors) {
      updatePunchEntryData(updatedAttendanceDetails);
      setHandleWarningMessage([]);
    } else {
      let yellowWarningDetails = [];
      updatedAttendanceDetails.forEach((element) => {
        if (element.inoutDetailsDayCrossing || element.twentyFourHoursExists) {
          yellowWarningDetails = [
            ...yellowWarningDetails,
            {
              id: element.id,
              message: element.inoutDetailsDayCrossing
                ? `${element.date} - The check-in/check-out time was neither later than the previous day's check-out nor earlier than the next day's check-in.`
                : `${element.date} - IN and OUT punches are 24 hours apart.`,
            },
          ];
        }
      });
      setHandleWarningMessage(yellowWarningDetails);
    }
  };

  const normalizeDate = (date) => {
    if (!date || typeof date !== "string") return date;

    const parts = date.split("-");
    return parts[0].length === 4 ? date : parts.reverse().join("-");
  };

  const updatePunchEntryData = async (updatedAttendanceDetails) => {
    try {
      setScreenLoading(true);
      const method = "PUT";
      const payloads = updatedAttendanceDetails.map((entry) => ({
        user: shiftDetails?.user_id,
        date: entry?.date.split("-").reverse().join("-"),
        entries: entry?.punch_entries?.map((data) => ({
          ...data,
          date: normalizeDate(data?.date),
        })),
        attendance_record_id: entry?.attendance_record_id,
        early_exit: entry?.early_exit ?? false,
      }));
      const requests = payloads.map((payload) =>
        customAPI(`${domain}attendance_manual_entry/`, method, payload)
      );
      const responses = await Promise.all(requests);
      const allSuccess = responses.every((res) => res.ok);
      if (allSuccess) {
        setEditState(true);
        setRecallApi(true);
        setEditDetail(false);
        setIsEditRecord(false);
        reCallApi(true);
        showToast("success", responses[0]?.responseDetails?.message);
        setScreenLoading(false);
      } else {
        showToast("error", responses[0]?.responseDetails?.message);
      }
    } catch (err) {
      showToast("error", err?.message);
    } finally {
      setScreenLoading(false);
    }
  };

  const hasTimeValidationErrors = () => {
    return attendanceDetails.some(
      (item) =>
        item.entryCountMissMatch ||
        item.properCheckinCheckOutTimeError ||
        item.shiftEndTimeBasedError ||
        item.duplicateEntries
    );
  };

  const handleValueModification = (arr) =>
    arr.map(({ date, direction, time }) => ({ date, direction, time }));

  const isChanged = attendanceDetails.some((item, index) => {
    const defaultItem = defaultData[index];
    const punchesChanged =
      JSON.stringify(handleValueModification(item.punch_entries)) !==
      JSON.stringify(handleValueModification(defaultItem.punch_entries));
    const earlyExitChanged =
      (item.early_exit ?? false) !== (defaultItem.early_exit ?? false);
    return punchesChanged || earlyExitChanged;
  });

  const enableSaveButton = isChanged;

  const theme = createTheme({
    palette: {
      primary: {
        main: "#00D4AA",
      },
      secondary: {
        main: "#6c757d",
      },
    },
    typography: {
      fontFamily:
        '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
  });

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Mui.Drawer
          anchor="right"
          open={editDetail}
          onClose={toggleDrawer("right", false)}
          sx={drawerStyle}
        >
          <Box sx={parentBoxStyle}>
            <Paper
              elevation={0}
              sx={{
                borderBottom: `1px solid ${themes?.miliedLightGray}`,
                borderRadius: 0,
              }}
            >
              <Box sx={childBoxStyleSpaceBetween}>
                <IconButton
                  onClick={() => {
                    setEditDetail(false);
                    setIsEditRecord(false);
                  }}
                  sx={doubleArrowStyle}
                >
                  <DoubleArrow />
                </IconButton>
              </Box>
              <Box sx={{ ml: 2.2 }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  Edit Attendance
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Modify existing punch records to correct attendance details or
                  update missing time entries.
                </Typography>
              </Box>
            </Paper>
            <Box sx={{ p: 2 }}>
              <UserDetailsRow
                userDetails={attendanceDetails[0]}
                isEditRecord={isEditRecord}
              />
            </Box>

            <Mui.Grid>
              <Mui.Grid container>
                <Mui.Grid xs={0.3}></Mui.Grid>
                <Mui.Grid
                  container
                  xs={11.2}
                  sx={{
                    p: 1,
                  }}
                >
                  <Mui.Grid item xs={3}>
                    <Mui.Typography sx={{ fontWeight: 600, mt: 0.5 }}>
                      AR Date Range
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid item xs={5.2}>
                    <DateRangePicker
                      initialSettings={{
                        startDate: start.toDate(),
                        endDate: end.toDate(),
                        applyClass: "custom-apply-btn",
                        cancelClass: "custom-cancel-btn",
                        maxDate: moment(),
                        locale: {
                          format: "DD/MM/YYYY",
                        },
                      }}
                      onCallback={handleCallback}
                    >
                      <Mui.TextField
                        id="reportrange"
                        variant="outlined"
                        label=""
                        placeholder="Select a date range"
                        value={label}
                        size="small"
                        InputProps={{
                          readOnly: true,
                          notched: false,
                          endAdornment: (
                            <Mui.InputAdornment position="end">
                              <Mui.IconButton>
                                <DateRangeIcon />
                              </Mui.IconButton>
                            </Mui.InputAdornment>
                          ),
                        }}
                        InputLabelProps={{ shrink: true, required: true }}
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            legend: {
                              display: "none",
                            },
                          },
                        }}
                      />
                    </DateRangePicker>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid xs={0.5}></Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid sx={{ padding: 1, ml: 2 }}>
              <Mui.Typography sx={{ fontWeight: 600, paddingTop: 0.5 }}>
                Punch Entries
              </Mui.Typography>
            </Mui.Grid>
            {screenLoading ? (
              <Loader />
            ) : (
              <StyledGrid container>
                <ContentGrid item xs={12}>
                  <Mui.Grid
                    container
                    sx={{
                      pointerEvents: !latestPayDate ? "none" : "auto",
                      opacity: !latestPayDate ? 0.6 : 1,
                    }}
                  >
                    {attendanceDetails?.map((data, index) => (
                      <PunchDetails
                        shiftDetails={shiftDetails}
                        attendanceDetails={data}
                        setUpdatePunchEntry={setUpdatePunchEntry}
                        updatePunchEntry={updatePunchEntry}
                        setEditState={setEditState}
                        departmentId={departmentId}
                        setGetEntryDetails={setGetEntryDetails}
                        setAttendanceDetails={setAttendanceDetails}
                        overallData={attendanceDetails}
                        setGetUpdatedData={setGetUpdatedData}
                      />
                    ))}
                    {warningMessage.length !== 0 &&
                    !hasTimeValidationErrors() ? (
                      <>
                        <Mui.Grid
                          container
                          sx={{
                            ml: 2,
                            mr: 2,
                            padding: 0.5,
                            backgroundColor: themes?.lightYellowColor,
                          }}
                        >
                          {warningMessage?.map((warningMsg, index) => (
                            <Mui.Typography
                              variant="body2"
                              color="error"
                              sx={{
                                fontSize: 17,
                                paddingLeft: 3,
                                paddingTop: 0.5,
                                fontWeight: "bold",
                              }}
                            >
                              {warningMsg.message}
                            </Mui.Typography>
                          ))}
                          <Mui.Typography
                            variant="body2"
                            color="error"
                            sx={{
                              fontSize: 17,
                              paddingLeft: 3,
                              paddingTop: 0.5,
                              fontWeight: "bold",
                            }}
                          >
                            Press OK if this is acceptable.
                          </Mui.Typography>
                        </Mui.Grid>

                        <Mui.Grid
                          container
                          gap={1}
                          sx={{
                            ...rowEndStyle,
                            paddingTop: 1,
                            paddingRight: 1,
                            paddingBottom: 2,
                          }}
                        >
                          <CustomButton
                            actionFuntion={() => {
                              setHandleWarningMessage([]);
                            }}
                            actionName="Cancel"
                            typeName="button"
                          />
                          <CustomButton
                            actionFuntion={() => {
                              const warningIds = warningMessage.map(
                                (w) => w.id
                              );
                              const updatedData = attendanceDetails.map(
                                (item) =>
                                  warningIds.includes(item.id)
                                    ? {
                                        ...item,
                                        validate: true,
                                        previosValidation: true,
                                      }
                                    : item
                              );
                              setAttendanceDetails(updatedData);
                              validateOverAllPunchEntries(updatedData);
                            }}
                            actionName="Ok"
                            typeName="button"
                          />
                        </Mui.Grid>
                      </>
                    ) : null}
                    {attendanceDetails?.map((attendance, index) => (
                      <Mui.Grid
                        container
                        sx={{
                          ml: 2,
                          mr: 2,
                          padding: 0.5,
                        }}
                      >
                        <ErrorHandle
                          attendance={attendance}
                          setErrorUpdate={setErrorUpdate}
                          updateError={updateError}
                        />
                      </Mui.Grid>
                    ))}
                  </Mui.Grid>
                  {warningMessage.length === 0 || hasTimeValidationErrors() ? (
                    <Mui.Grid container>
                      <Mui.Grid item xs={2} sx={{ ml: 1.5 }}></Mui.Grid>
                      <Mui.Grid item xs={7}></Mui.Grid>
                      <Mui.Grid
                        container
                        xs={2.7}
                        sx={{
                          paddingBottom: 2,
                        }}
                        gap={1}
                      >
                        <CustomButtonWithBorder
                          actionFuntion={() => {
                            setHandleWarningMessage([]);
                            setAttendanceDetails(
                              defaultData.map((item) => ({
                                ...item,
                                twentyFourHoursExists: false,
                                entryCountMissMatch: false,
                                properCheckinCheckOutTimeError: false,
                                inoutDetailsDayCrossing: false,
                                shiftEndTimeBasedError: false,
                              }))
                            );
                            setUpdatePunchEntry(true);
                          }}
                          actionName="Reset"
                          typeName="button"
                          disableAction={!enableSaveButton}
                          handleBgColor={true}
                        />
                        {!enableSaveButton ? (
                          <Mui.Tooltip
                            arrow
                            slotProps={tooltipStyleProps}
                            title="No modifications were found."
                          >
                            <span>
                              <CustomButtonWithOutLoader
                                actionFuntion={() => {
                                  validateOverAllPunchEntries(
                                    attendanceDetails
                                  );
                                }}
                                actionName="Save"
                                typeName="button"
                                disableAction={true}
                              />
                            </span>
                          </Mui.Tooltip>
                        ) : (
                          <CustomButton
                            actionFuntion={() => {
                              validateOverAllPunchEntries(attendanceDetails);
                            }}
                            actionName="Save"
                            typeName="button"
                            disableAction={screenLoading}
                          />
                        )}
                      </Mui.Grid>
                    </Mui.Grid>
                  ) : null}

                  <Mui.Grid container sx={{ mt: 0.5 }}></Mui.Grid>
                </ContentGrid>
              </StyledGrid>
            )}
          </Box>
        </Mui.Drawer>
      </ThemeProvider>
    </React.Fragment>
  );
};

const StyledGrid = styled(Mui.Grid)`
  height: 80vh;
`;

const ContentGrid = styled(Mui.Grid)`
  width: 80%;
`;
